import "@arco-design/web-react/es/Popconfirm/style";
import _Popconfirm from "@arco-design/web-react/es/Popconfirm";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import React from 'react';
export function ButtonDelete({
  onOk
}) {
  return /*#__PURE__*/React.createElement(_Popconfirm, {
    title: "\u786E\u5B9A\u5220\u9664?",
    onOk: onOk
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "secondary",
    status: "danger",
    size: "small"
  }, "\u5220\u9664"));
}